import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-bullet-status',
  templateUrl: './bullet-status.component.html',
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class BulletStatusComponent {
  @Input() title: string;

  @Input() value: number;

  @Input() loading: boolean;

  @Input() bulletClass: string;

  @Output() action: EventEmitter<any> = new EventEmitter();

  get dotColor(): string {
    const map: Record<string, string> = {
      'preparing-order-vendor': '#8781FF',
      'count-implementation': '#0D62FF',
      'count-installed': '#0f2744',
    };
    return map[this.bulletClass] ?? '#0D62FF';
  }

  public clickBox(): void {
    this.action.emit();
  }
}
